const PasswordIcon = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 8V5C4 2.79086 5.79086 1 8 1C10.2091 1 12 2.79086 12 5V8"
        stroke="#737373"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M1 8H15V17C15 18.1046 14.1046 19 13 19H3C1.89543 19 1 18.1046 1 17V8Z"
        stroke="#737373"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <rect
        x="10.5"
        y="13.5"
        width="0.01"
        height="0.01"
        stroke="#737373"
        stroke-width="3"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default PasswordIcon;
